import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var VolumeMax = function VolumeMax(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19.7479 5C21.1652 6.9701 22 9.3875 22 11.9998s-.8348 5.0298-2.2521 7m-4.0026-11C16.5362 9.1338 17 10.5127 17 12s-.4638 2.8662-1.2547 4M9.6343 4.3656 6.4686 7.5313c-.173.173-.2594.2594-.3603.3213a1 1 0 0 1-.289.1197c-.1152.0276-.2374.0276-.482.0276H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 16 3.04 16 3.6 16h1.7373c.2446 0 .3668 0 .482.0277.102.0245.1995.0649.289.1197.1009.0618.1874.1483.3603.3213l3.1657 3.1656c.4284.4284.6426.6426.8265.6571a.5.5 0 0 0 .4194-.1738C11 19.9773 11 19.6744 11 19.0686V4.9313c0-.6058 0-.9087-.1198-1.049a.5.5 0 0 0-.4194-.1737c-.1839.0145-.3981.2286-.8265.657"
    })
  }));
};
export default VolumeMax;